import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

function clickOnRemove() {
    const category = GA_EVENTS.wheelAlignmentInfoLightBox.category;
    const action = GA_EVENTS.wheelAlignmentInfoLightBox.actions.clickOnRemove;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function clickOnOk() {
    const category = GA_EVENTS.wheelAlignmentInfoLightBox.category;
    const action = GA_EVENTS.wheelAlignmentInfoLightBox.actions.clickOnOk;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function clickOnLearnMore() {
    const category = GA_EVENTS.wheelAlignmentInfoLightBox.category;
    const action = GA_EVENTS.wheelAlignmentInfoLightBox.actions.clickOnLearnMore;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function close() {
    const category = GA_EVENTS.wheelAlignmentInfoLightBox.category;
    const action = GA_EVENTS.wheelAlignmentInfoLightBox.actions.close;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function open(from) {
    const category = GA_EVENTS.wheelAlignmentInfoLightBox.category;
    const action = GA_EVENTS.wheelAlignmentInfoLightBox.actions.open;
    const label = `Opened from within ${from}`;

    setBehaviourEvent({ category, action, label });
}

export {
    clickOnRemove,
    clickOnOk,
    clickOnLearnMore,
    close,
    open
};
